import { Permission } from '../common/permision';

export const enum GenerationType {
  Frame = 'frame',
  Reference = 'reference',
}

export type VideoModelCode =
  | 'kling-3.0/standard' // 废弃，不可使用，旧数据还在
  | 'sora-2' // 废弃，不可使用，旧数据还在
  | 'grok-imagine' // 废弃，不可使用，旧数据还在
  | 'grok-imagine-video'
  | 'wan2.6-r2v-flash' // 废弃，不可使用，旧数据还在
  | 'wan2.7-i2v'
  | 'wan2.7-r2v'
  | 'veo3.1-fast' // 废弃，不可使用，旧数据还在
  | 'sora-2-pro' // 废弃，不可使用，旧数据还在
  | 'doubao-seedance-1-5-pro-251215' // 废弃，不可使用，旧数据还在
  | 'dreamina_seedance'
  | 'doubao-seedance-2-0-260128'
  | 'dreamina_seedance_fast'
  | 'doubao-seedance-2-0-fast-260128'
  | 'doubao-seedance-2-0-mini-260615'
  | 'dreamina_seedance_pro'
  | 'doubao-seedance-2-5-260628'
  | 'happyhorse-1.0-r2v'
  | 'veo3.1-fast-official'
  | 'sora-2-pro-official'
  | 'smile-horse'
  | 'wan3.0-video-prime';

export interface ModelSpec {
  name: string;
  /**
   * 信用点
   */
  credit: number;
  /**
   * 查看和选择该模型所需的权限
   */
  permission?: Permission[];
  /**
   * 是否支持首尾帧
   *
   * @default false
   */
  frame_image?: boolean;
  /**
   * 是否支持元素引用
   *
   * @default false
   */
  reference_element?: boolean;
  /**
   * 是否支持参考图
   *
   * @default false
   */
  reference_image?: boolean;
  /**
   * 是否支持长视频
   *
   * @default false
   */
  long_video?: boolean;
  /**
   * 时长要求
   *
   * 可以是一个范围，或者指定的时长
   */
  duration:
    | {
        min: number;
        max: number;
      }
    | number[];
  image_number?: {
    frame?: {
      min?: number;
      max?: number;
    };
    reference?: {
      min?: number;
      max?: number;
    };
  };
  audio_number?: number;
  /**
   * 提示词最大长度
   */
  max_prompt?: number;
  /**
   * 是否弃用
   */
  deprecated?: boolean;
}

/**
 * 各个模型的需求规格
 */
export const videoModelSpecs = new Map<VideoModelCode, ModelSpec>();

videoModelSpecs.set('kling-3.0/standard', {
  deprecated: true,
  name: '可灵3.0',
  credit: 10,
  frame_image: true,
  reference_image: true,
  reference_element: true,
  duration: {
    min: 3,
    max: 15,
  },
  image_number: {
    reference: {
      min: 1,
      max: 2,
    },
  },
});

videoModelSpecs.set('doubao-seedance-1-5-pro-251215', {
  deprecated: true,
  name: 'Doubao-Seedance-1.5-pro',
  credit: 10,
  frame_image: true,
  duration: {
    min: 2,
    max: 12,
  },
});

videoModelSpecs.set('dreamina_seedance_pro', {
  permission: [Permission.海外版火山云模型],
  name: 'Dreamina-SD-pro',
  credit: 16,
  frame_image: true,
  reference_image: true,
  reference_element: true,
  image_number: {
    reference: {
      min: 1,
      max: 30,
    },
  },
  audio_number: 1,
  duration: {
    min: 4,
    max: 30,
  },
});

videoModelSpecs.set('doubao-seedance-2-5-260628', {
  permission: [Permission.火山云SD2_5模型],
  name: 'SD-Pro',
  credit: 16,
  frame_image: true,
  reference_image: true,
  reference_element: true,
  image_number: {
    reference: {
      min: 1,
      max: 30,
    },
  },
  audio_number: 1,
  duration: {
    min: 4,
    max: 30,
  },
});

videoModelSpecs.set('dreamina_seedance', {
  permission: [Permission.海外版火山云模型],
  name: 'Dreamina-SD',
  credit: 11,
  frame_image: true,
  reference_image: true,
  reference_element: true,
  image_number: {
    reference: {
      min: 1,
      max: 9,
    },
  },
  audio_number: 1,
  duration: {
    min: 4,
    max: 15,
  },
});

videoModelSpecs.set('doubao-seedance-2-0-260128', {
  permission: [Permission.火山云模型],
  name: 'SD',
  credit: 11,
  frame_image: true,
  reference_image: true,
  reference_element: true,
  image_number: {
    reference: {
      min: 1,
      max: 9,
    },
  },
  audio_number: 1,
  duration: {
    min: 4,
    max: 15,
  },
});

videoModelSpecs.set('dreamina_seedance_fast', {
  permission: [Permission.海外版火山云模型, Permission.火山云模型SD_FAST],
  name: 'Dreamina-SD-fast',
  credit: 5,
  frame_image: true,
  reference_image: true,
  reference_element: true,
  long_video: true,
  image_number: {
    reference: {
      min: 1,
      max: 9,
    },
  },
  audio_number: 1,
  duration: {
    min: 4,
    max: 15,
  },
});

videoModelSpecs.set('doubao-seedance-2-0-fast-260128', {
  permission: [Permission.火山云模型],
  name: 'SD-fast',
  credit: 5,
  frame_image: true,
  reference_image: true,
  reference_element: true,
  long_video: true,
  image_number: {
    reference: {
      min: 1,
      max: 9,
    },
  },
  audio_number: 1,
  duration: {
    min: 4,
    max: 15,
  },
});

videoModelSpecs.set('wan3.0-video-prime', {
  permission: [Permission.Wan3模型],
  name: 'Wan3',
  credit: 5,
  duration: {
    min: 2,
    max: 30,
  },
  frame_image: true,
  reference_image: true,
  image_number: {
    frame: {
      min: 1,
      max: 2,
    },
    reference: {
      min: 1,
      max: 9,
    },
  },
});

videoModelSpecs.set('doubao-seedance-2-0-mini-260615', {
  permission: [Permission.火山云模型],
  name: 'SD-mini',
  deprecated: true,
  credit: 5,
  frame_image: true,
  reference_image: true,
  reference_element: true,
  image_number: {
    reference: {
      min: 1,
      max: 9,
    },
  },
  audio_number: 1,
  duration: {
    min: 4,
    max: 15,
  },
});

videoModelSpecs.set('smile-horse', {
  deprecated: true,
  credit: 5,
  name: '微笑马',
  duration: {
    min: 3,
    max: 15,
  },
  reference_image: true,
  image_number: {
    reference: {
      max: 8,
    },
  },
});

videoModelSpecs.set('wan2.7-i2v', {
  name: 'Wan',
  deprecated: true,
  credit: 10,
  frame_image: true,
  duration: {
    min: 2,
    max: 15,
  },
});

videoModelSpecs.set('wan2.7-r2v', {
  name: 'Wan',
  deprecated: true,
  credit: 10,
  duration: {
    min: 2,
    max: 10,
  },
  reference_image: true,
  image_number: {
    reference: {
      max: 5,
    },
  },
});

videoModelSpecs.set('veo3.1-fast', {
  deprecated: true,
  name: 'Veo3.1-fast',
  credit: 10,
  frame_image: true,
  reference_image: true,
  duration: [8],
  image_number: {
    reference: {
      min: 1,
      max: 3,
    },
  },
});

videoModelSpecs.set('sora-2', {
  deprecated: true,
  name: 'Sora-2',
  credit: 10,
  duration: [10, 15],
  frame_image: true,
});

videoModelSpecs.set('sora-2-pro', {
  deprecated: true,
  name: 'Sora-2-pro',
  credit: 10,
  frame_image: true,
  duration: [15, 25],
});

videoModelSpecs.set('wan2.6-r2v-flash', {
  deprecated: true,
  name: 'Wan2.6-r2v-flash',
  credit: 10,
  reference_image: true,
  duration: {
    min: 2,
    max: 10,
  },
  image_number: {
    reference: {
      max: 5,
    },
  },
});

videoModelSpecs.set('grok-imagine', {
  deprecated: true,
  name: 'Poyo-Grok',
  credit: 10,
  duration: [6, 10],
  frame_image: true,
});

videoModelSpecs.set('happyhorse-1.0-r2v', {
  name: '快乐小马',
  deprecated: true,
  credit: 5,
  duration: {
    min: 3,
    max: 15,
  },
  reference_image: true,
  image_number: {
    reference: {
      max: 5,
    },
  },
});

videoModelSpecs.set('sora-2-pro-official', {
  deprecated: true,
  name: 'Sora',
  credit: 10,
  duration: [4, 8, 12, 16, 20],
  frame_image: true,
  image_number: {
    frame: {
      min: 1,
      max: 1,
    },
  },
});

videoModelSpecs.set('veo3.1-fast-official', {
  deprecated: true,
  name: 'Veo',
  credit: 10,
  duration: [8],
  reference_image: true,
  max_prompt: 1000,
  image_number: {
    frame: {
      min: 1,
      max: 2,
    },
    reference: {
      min: 1,
      max: 3,
    },
  },
});

export const videoModelNameMap = new Map(
  videoModelSpecs.entries().map(([code, spec]) => [code, spec.name]),
);

export const isVideoEditModelSupported = (model: VideoModelCode) => {
  return (
    model.startsWith('doubao-seedance') &&
    model !== 'doubao-seedance-2-5-260628'
  );
};

export const isSupportedAssets = (model: VideoModelCode) => {
  return (
    model === 'doubao-seedance-1-5-pro-251215' ||
    model === 'doubao-seedance-2-5-260628' ||
    model === 'doubao-seedance-2-0-260128' ||
    model === 'doubao-seedance-2-0-fast-260128' ||
    model === 'doubao-seedance-2-0-mini-260615'
  );
};
